import { render } from "./HeroProfile.vue?vue&type=template&id=226b9364"
import script from "./HeroProfile.vue?vue&type=script&lang=js"
export * from "./HeroProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__